module.exports = __webpack_public_path__ + "static/media/Niveau_elN3_3_830614.d56f5831.png";